import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {Wheel2Cell} from "@treeosk/common"
import queries from "../../../queries";
import SpecificCellPreview from "./SpecificCellPreview";

const Wheel2CellPreview = ({ cell }) => (
  <SpecificCellPreview
    cell={cell}
    defaultRender={() => <FontAwesomeIcon icon={['far', 'image']} />}
    query={queries.cells.wheel2.get}
    renderingCondition={(wheel) => !!wheel.wheel_uri || /"source"\s*:\s*"generated"/.test(wheel.config || '')}
  >
    {(wheel) => <Wheel2Cell preview={true} cell={wheel} />}
  </SpecificCellPreview>
);

export default Wheel2CellPreview;
